/**
 * Como a campanha distribui os números da sorte (V1_1_214).
 *
 * Espelha o enum DrawModes do back-end. O valor vive em Campaign.drawModeId, que é
 * NOT NULL com default 1 no banco — campanha nenhuma fica sem modo.
 */
const DrawModes = {
    /** A cada X reais doados, 1 número. É o comportamento que sempre existiu. */
    ByValue: 1,
    /** A quantidade vem do produto de doação escolhido (CampaignProduct.numberDrawQuantity). */
    ByProduct: 2,
};

export { DrawModes };
